module.exports = __webpack_public_path__ + "media/images/pen_mediumslateblue-99a3dc22.png";